// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".suspended {\n  pointer-events: none;\n  opacity: 0.8;\n}\n\n.img-subscription {\n  aspect-ratio: 1/1;\n  border-radius: 5px;\n  object-fit: cover;\n  overflow: hidden;\n  width: 50%;\n}\n\n.renovate-item {\n  margin-top: 0.5rem;\n  --border-width: 1px;\n  --background: transparent;\n  --border-radius: 0.5rem;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
